import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5de55ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-search" }

export function render(_ctx: any,_cache: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      ref: "searchInput",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args))),
      onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openDropdown && _ctx.openDropdown(...args))),
      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeDropDown && _ctx.closeDropDown(...args))),
      class: "custom-input"
    }, null, 544), [
      [_vModelText, _ctx.searchQuery]
    ]),
    _createVNode(_component_Multiselect, {
      ref: "multiSelectRef",
      modelValue: _ctx.selectedValue,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedValue) = $event)),
      mode: _ctx.mode,
      "close-on-select": true,
      label: _ctx.trackBy,
      trackBy: _ctx.trackBy,
      searchable: false,
      canDeselect: false,
      options: _ctx.arrOptions,
      valueProp: "id",
      "allow-empty": false,
      required: true,
      class: _normalizeClass(["form-select form-select-solid", _ctx.className]),
      onOpen: _ctx.handleOpen,
      onClose: _ctx.handleClose,
      placeholder: "Select Customer"
    }, null, 8, ["modelValue", "mode", "label", "trackBy", "options", "class", "onOpen", "onClose"])
  ]))
}